import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { SanitizeHtml } from 'app/src/shared/helpers'
import { getProcessingInstructions } from 'app/src/shared/helpers/htmlToReact'
import { Parser } from 'html-to-react'
import { CSSProperties, useEffect, useState } from 'react'

//Tailwind vuole conoscerli a buildtime...
const colorVariants: { [colorName: string]: string } = {
  cardBackGround: 'bg-[--card-background]',
  neutralGray100: 'bg-[#EBEBEB]',
  lightGrayBackground: 'bg-[#FAFAFA]',
  bannerBackGround: 'bg-[#539DDD]',
}
type PageWidgetProps = {
  background?: string
  containerStyleOverrides?: CSSProperties
  containerClassNamesOverrides?: string
  containerDefaultClassNames?: string
  childrenDefaultClassNames?: string
  childrenClassNames?: string
}

export function PageWidget(props: React.PropsWithChildren<PageWidgetProps>) {
  return (
    <div
      className={`${props?.containerDefaultClassNames ?? 'pl-2 pr-2 lg:pl-4 lg:pr-4 xl:pl-8 xl:pr-8'} ${colorVariants[props.background!] ?? ''} ${props.containerClassNamesOverrides ?? ''}`}
      style={props.containerStyleOverrides}
    >
      <div
        className={`mx-auto max-w-[var(--max-application-size)] ${props.childrenDefaultClassNames ?? 'p-3 pt-3'} ${props.childrenClassNames ?? ''}`}
      >
        {props.children}
      </div>
    </div>
  )
}

export function DynamicPageWidget(
  props: {
    sectionItem?: pageconfigurationsApi.SectionItem
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentRenderer?: (props: any) => React.ReactNode
  } & PageWidgetProps,
) {
  const [customContent, setCustomContent] = useState<React.ReactNode>()

  useEffect(() => {
    if (props.sectionItem) {
      const workerFunc = async () => {
        switch (props.sectionItem?.renderingMode) {
          case 'native':
            setCustomContent(props.componentRenderer?.(props.sectionItem?.parameters) ?? <></>)
            break
          case 'htmlfragment': {
            const sectionParameters = props.sectionItem.parameters as pageconfigurationsApi.HtmlFragmentSectionItemParameters
            const fragment = sectionParameters.htmlFragment ?? (await (await fetch(sectionParameters.htmlFragmentPath!)).text())
            setCustomContent(SanitizeHtml(fragment))
            break
          }
          default:
            setCustomContent(<></>)
        }
      }

      workerFunc()
    }
  }, [props])

  return (
    props?.sectionItem && (
      <PageWidget {...props} containerStyleOverrides={props.sectionItem?.containerStyleOverrides?.style}>
        {customContent &&
          (typeof customContent === 'string'
            ? Parser().parseWithInstructions(customContent, () => true, getProcessingInstructions())
            : customContent)}
      </PageWidget>
    )
  )
}
